import { Component, OnInit } from '@angular/core';
import { RestApiService } from '../shared/restApiServices/restapi.service';
import { isUndefined } from "util";
import { Router } from '@angular/router';

@Component({
  selector: 'codeforgotPass',
  templateUrl: './codeforgotPass.html',
  styleUrls: ['./codeforgotPass.css']
})
export class CodeForgotPasswordComponent implements OnInit {

  userName: string;
  password: string;
  reenterpassword: string;
  signUpFail: boolean;
  signUpFailMsg: string;
  email: string;
  color = 'green';
  isShowLoader = false;
  userNameEmpty;
  passwordEmpty;
  signUpCode: string;
  signUpCodeEmpty: string;

  constructor(private restApiService: RestApiService, private router: Router) {
    this.signUpFail = false;
    this.signUpFailMsg = "";

  }

  ngOnInit() {
    // this.userName = "+91";
  }

  codeRequest(userName) {
    if (this.userName == null || isUndefined(this.userName) || this.userName == "") {
      this.userNameEmpty = "on-error";
      return;
    }
    else {
      this.restApiService.forgotPasswordService(this.userName).subscribe(
        result => {
          if (result.success) {
            this.isShowLoader = false;
            // this.router.navigateByUrl('/forgotPassword');
            this.router.navigate(['/forgotPassword'],{ queryParams: { email: this.userName} })
          }
          else {
            this.isShowLoader = false;
            this.signUpFailMsg = result.value;
            this.signUpFail = true;
          }
        })
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/getCodeForgetPassword/codeforgotPass.ts